export let InvoicePaymentStatus;
(function (InvoicePaymentStatus) {
  InvoicePaymentStatus["PAID"] = "PAID";
  InvoicePaymentStatus["PAYMENT_NOT_ENABLED"] = "PAYMENT_NOT_ENABLED";
  InvoicePaymentStatus["PENDING"] = "PENDING";
  InvoicePaymentStatus["UNPAID"] = "UNPAID";
  InvoicePaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(InvoicePaymentStatus || (InvoicePaymentStatus = {}));